import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard




import Login from "../pages/Authentication/Login";
import ChangePassword from '../pages/Authentication/ChangePassword'
import WebsiteSettings from "../pages/WebsiteSettings";
import Dashboard from "../pages/Dashboard";
import Categories from "../pages/Categories/Category";
import SubCategories from "../pages/Categories/SubCategory";
import Products from "../pages/Products";
import CategorySort from "../pages/Categories/Category/CategorySort";
import SubCategorySort from "../pages/Categories/SubCategory/SubCategorySort";
import ProductSort from "../pages/Products/ProductSort";
const authProtectedRoutes = [

  { path: "/dashboard", component: <Dashboard /> },
  { path: "/categories", component: <Categories /> },
  { path: "/sub-categories", component: <SubCategories /> },
  { path: "/products", component: <Products /> },
  { path: "/website-settings", component: <WebsiteSettings /> },
   { path: "/change-password", component: <ChangePassword /> },
  { path: "/category-sort", component: <CategorySort /> },
  { path: "/subcategory-sort", component: <SubCategorySort /> },
  { path: "/product-sort", component: <ProductSort /> },


  





  //User Profile
  ,

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/login" />,
  },
  { path: "*", component: <Navigate to="/login" /> },
];

const publicRoutes = [
  // Authentication Page
  // { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  // { path: "/forgot-password", component: <ForgetPasswordPage /> },
  // { path: "/register", component: <Register /> },

  //AuthenticationInner pages


];

export { authProtectedRoutes, publicRoutes };